import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllUsersSummary,
  getUserByIdRequest,
  getAllAccessRequest,
  updateUserRequest,
  deleteUserRequest,
  getCodeRequest,
  changePasswordRequest,
  getMenuCategoriesRequest,
} from "../../services/usersService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getCode(email) {
  try {
    const response = yield call(getCodeRequest, email);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_CODE_SUCCESS,
      });
      notification["success"]({
        message:
          "Инструкциите за смяна на паролата са изпратени на въведения имейл.",
      });
    } else if (response[0] === 429) {
      notification["error"]({
        message: "Грешка",
        description: "Прекалено много заявки. Моля, опитайте по-късно.",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка, неуспешно изпращане.",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getUserDetails({ userId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getUserByIdRequest, userId, token);

    if (response[0] === 200) {
      yield put({
        type: actions.GET_USER_DETAILS_SUCCESS,
        user: response[1],
      });
    } else {
      yield put({
        type: actions.GET_USER_DETAILS_FAILURE,
      });
      notification["error"]({
        message: "Неуспешно зареждане на детайли за потребител.",
      });
    }
  } catch (error) {
    yield put({
      type: actions.GET_USER_DETAILS_FAILURE,
    });
    notification["error"]({
      message: "Неуспешно зареждане на детайли за потребител.",
    });
  }
}

export function* changePassword(payload) {
  try {
    const response = yield call(changePasswordRequest, payload);
    if (response[0] === 200) {
      yield put({
        type: actions.CHANGE_PASSWORD_SUCCESS,
      });
      notification["success"]({
        message: "Успешна промяна",
      });
      window.location = "/signin";
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка, неуспешна промяна",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getUsers() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllUsersSummary, token);

    if (response[0] === 200) {
      yield put({
        type: actions.GET_USERS_SUCCESS,
        users: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно взимане на потребители",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно взимане на потребители",
    });
  }
}

export function* getAllAccess() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllAccessRequest, token);

    if (response[0] === 200) {
      yield put({
        type: actions.GET_ALL_ACCESS_SUCCESS,
        allAccess: response[1],
      });
    } else {
      notification["error"]({
        message: "Неуспешно получаване на всичко права",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешно получаване на всичко права",
    });
  }
}

export function* deleteUser({ user }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteUserRequest, token, user);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_USER_SUCCESS,
      });

      notification["success"]({
        message: "Успешно изтриване.",
      });
    } else {
      notification["error"]({
        message: "Неуспешено изтриване.",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешено изтриване.",
    });
  }
}

export function* updateUser({ user }) {
  const token = getToken().get("idToken");
  try {
    const response = yield call(updateUserRequest, user, token);
    if (response[0] === 200) {
      yield put({
        type: actions.UPDATE_USER_SUCCESS,
        user,
      });
      notification["success"]({
        message: "Успешен запис",
      });
    } else {
      notification["error"]({
        message: "Неуспешен запис",
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешен запис",
    });
  }
}

export function* getMenuCategories({ organizaitonId }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getMenuCategoriesRequest,
      token,
      organizaitonId
    );

    if (response[0] === 200) {
      yield put({
        type: actions.GET_MENU_CATEGORIES_SUCCESS,
        menuCategories: response[1],
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_USERS_REQUEST, getUsers),
    yield takeEvery(actions.GET_USER_DETAILS_REQUEST, getUserDetails),
    yield takeEvery(actions.GET_ALL_ACCESS_REQUEST, getAllAccess),
    yield takeEvery(actions.UPDATE_USER_REQUEST, updateUser),
    yield takeEvery(actions.DELETE_USER_REQUEST, deleteUser),
    yield takeEvery(actions.GET_CODE_REQUEST, getCode),
    yield takeEvery(actions.CHANGE_PASSWORD_REQUEST, changePassword),
    yield takeEvery(actions.GET_MENU_CATEGORIES_REQUEST, getMenuCategories),
  ]);
}
